module.exports = __webpack_public_path__ + "static/media/faxcover_140.46163e47.ico";